import {
  Component,
  computed,
  EventEmitter,
  OnInit,
  Output,
  signal,
  Signal,
  WritableSignal,
  inject,
} from '@angular/core';
import { BoFormsModule } from '@bo/ng-forms';
import { HttpParams } from '@angular/common/http';
import {
  FilterButtonComponent,
  FilterGroup,
} from '../../../../../shared/components/filter-button/filter-button.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxCurrencyDirective } from '@dintecom/ngx-currency';
import { updateParamsObjectToPageOne } from '../../../../../shared/utils/filter-utils';

@Component({
  selector: ' app-recurring-topup-filter',
  imports: [BoFormsModule, NgxCurrencyDirective, FilterButtonComponent],
  templateUrl: './recurring-filter.component.html',
})
export class RecurringFilterComponent implements OnInit {
  readonly router = inject(Router);
  readonly route = inject(ActivatedRoute);

  @Output() query: EventEmitter<HttpParams> = new EventEmitter<HttpParams>();
  resetHandled = signal(false);

  private queryParams = new HttpParams();
  protected filterGroup: Array<FilterGroup> = [];

  protected minAmount: WritableSignal<string | null> = signal(null);
  protected maxAmount: WritableSignal<string | null> = signal(null);

  protected hasAmountFilters: Signal<boolean> = computed(() => {
    return !!this.minAmount() || !!this.maxAmount();
  });

  ngOnInit(): void {
    this.minAmount.set(this.route.snapshot.queryParams['amount_gte'] ?? null);
    this.maxAmount.set(this.route.snapshot.queryParams['amount_lte'] ?? null);
  }

  onFilter() {
    // create "clean" query params, otherwise historical queries gets added again.
    const existingParams = this.route.snapshot.queryParams;
    this.queryParams = new HttpParams().appendAll(existingParams);

    this.processAmounts();

    // Navigate with updated filters and reset page to 1
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: updateParamsObjectToPageOne(this.queryParams),
    });
  }

  processAmounts() {
    if (this.minAmount()) {
      this.queryParams = this.queryParams.set('amount_gte', this.minAmount()?.toString() ?? '');
    } else {
      this.queryParams = this.queryParams.delete('amount_gte');
    }

    if (this.maxAmount()) {
      this.queryParams = this.queryParams.set('amount_lte', this.maxAmount()?.toString() ?? '');
    } else {
      this.queryParams = this.queryParams.delete('amount_lte');
    }
  }

  handleReset() {
    this.minAmount.set(null);
    this.maxAmount.set(null);
    this.resetHandled.set(true);
  }
}
